import { queryOptions } from "@tanstack/react-query";
import fetcher from "@/core/lib/fetcher";
import type { APIResponse } from "@/core/types/utils";
import type { RoomBlock, RoomBlockPayload } from "./roomBlocks.types";

export const getRoomBlocks = (siteId: string, token: string) =>
	queryOptions({
		queryKey: ["roomBlocks", siteId, token],
		queryFn: () =>
			fetcher
				.auth(`Bearer ${token}`)
				.get(
					import.meta.env.VITE_API_BOOKING + `property/${siteId}/rooms-blocks`,
				)
				.json<APIResponse<RoomBlock[]>>(),
	});

export const getRoomBlockById = (
	siteId: string,
	token: string,
	roomBlockId: string,
) =>
	queryOptions({
		queryKey: ["roomBlock", siteId, token, roomBlockId],
		queryFn: () =>
			fetcher
				.auth(`Bearer ${token}`)
				.get(
					import.meta.env.VITE_API_BOOKING +
						`property/${siteId}/rooms-blocks/${roomBlockId}`,
				)
				.json<APIResponse<RoomBlock>>(),
	});

export const createRoomBlock = (
	data: RoomBlockPayload,
	siteId: string,
	token: string,
) =>
	fetcher
		.auth(`Bearer ${token}`)
		.url(import.meta.env.VITE_API_BOOKING + `property/${siteId}/rooms-blocks`)
		.post(data)
		.json<APIResponse<RoomBlock>>();

export const updateRoomBlock = (
	data: RoomBlockPayload,
	siteId: string,
	token: string,
	roomBlockId: string,
) =>
	fetcher
		.auth(`Bearer ${token}`)
		.url(
			import.meta.env.VITE_API_BOOKING +
				`property/${siteId}/rooms-blocks/${roomBlockId}`,
		)
		.put(data)
		.json<APIResponse<RoomBlock>>();

export const archiveRoomBlock = (
	siteId: string,
	token: string,
	roomBlockId: string,
) =>
	fetcher
		.auth(`Bearer ${token}`)
		.url(
			import.meta.env.VITE_API_BOOKING +
				`property/${siteId}/rooms-blocks/${roomBlockId}`,
		)
		.delete()
		.json<APIResponse<null>>();
